import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  MODAL_DATA,
  MODAL_REF,
  ModalRef,
} from '@services/components/ModalService/modal.ref';

export interface ColorConflictModalData {
  products: string[];
}

@Component({
  selector: 'app-color-conflict-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './color-conflict-modal.component.html',
  styleUrl: './color-conflict-modal.component.css',
})
export class ColorConflictModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<boolean>;
  protected readonly data = inject<ColorConflictModalData>(MODAL_DATA);

  public onConfirm(): void {
    this.modalRef.close({ reason: 'confirm', data: true });
  }

  public onCancel(): void {
    this.modalRef.close({ reason: 'cancel', data: false });
  }
}
